export const googleMaps = {
  'basemap': {
    name: 'Straßen',
    attrib: '&copy; <a href="https://www.google.de/maps">Google Maps</a>',
    layer: 'https://mt.google.com/vt?&x={x}&y={y}&z={z}'
  },
  'satellite': {
    name: 'Satellit / Luftbild',
    attrib: '&copy; <a href="https://www.google.de/maps">Google Maps</a>',
    layer: 'https://mt.google.com/vt?lyrs=s&x={x}&y={y}&z={z}'
  },
  'hybrid': {
    name: 'Hybrid',
    attrib: '&copy; <a href="https://www.google.de/maps">Google Maps</a>',
    layer: 'https://mt.google.com/vt?lyrs=y&x={x}&y={y}&z={z}'
  }
}

export const openStreetMap = {
  'basemap': {
    name: 'Straßen International',
    attrib: '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a>',
    layer: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  },
  'StreetsDE': {
    name: 'Straßen',
    attrib: '<a href="http://openstreetmap.de">OpenStreetMap DE</a>',
    layer: 'https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png'
  },
  'BlackWhite': {
    name: 'Schwarz-Weiß',
    attrib: '<a href="http://openstreetmap.org">OpenStreetMap</a>',
    layer: 'http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png'
  }
}

export default {
  googleMaps,
  openStreetMap
}
